import { Ticket } from "callable-data-objects";
import React from "react";
import { List, Table, TextArea } from "semantic-ui-react";
type AssignmentDetailsProps = {
  ticket: Ticket;
};
const PortingDetails = ({ ticket }: AssignmentDetailsProps) => {
  const { portRequest } = ticket;
  const {
    cno,
    mbn,
    associatedDDIs,
    rangeDDIs,
    newAddress,
    originalAddress,
    contactName,
    contactTelephone,
    contactMobile,
    specialNotes
  } = portRequest;

  return (
    <Table size='small' padded={false} basic>
      <Table.Body>
        {cno !== '' && (<Table.Row>
          <Table.Cell>CNO</Table.Cell>
          <Table.Cell>{cno}</Table.Cell>
        </Table.Row>)}
        {mbn !== '' && ( <Table.Row>
          <Table.Cell>Main Billing Number</Table.Cell>
          <Table.Cell>{mbn}</Table.Cell>
        </Table.Row>)}
        {associatedDDIs !== '' && ( <Table.Row>
          <Table.Cell>Associated Numbers</Table.Cell>
          <Table.Cell>{associatedDDIs}</Table.Cell>
        </Table.Row>)}
       {rangeDDIs !== '' && ( <Table.Row>
          <Table.Cell>Range Numbers</Table.Cell>
          <Table.Cell>{rangeDDIs}</Table.Cell>
        </Table.Row>)}
        {originalAddress && ( <Table.Row>
          <Table.Cell>Original Address</Table.Cell>
          <Table.Cell>
            <List>
              <List.Item>{originalAddress.line1}</List.Item>
              <List.Item>{originalAddress.line2}</List.Item>
              <List.Item>{originalAddress.level2}</List.Item>
              <List.Item>{originalAddress.level1}</List.Item>
              <List.Item>{originalAddress.postalCode}</List.Item>
              <List.Item>{originalAddress.country}</List.Item>
            </List>
          </Table.Cell>
        </Table.Row>)}
        {newAddress && (<Table.Row>
          <Table.Cell>New Address</Table.Cell>
          <Table.Cell>
            <List>
              <List.Item>{newAddress.line1}</List.Item>
              <List.Item>{newAddress.line2}</List.Item>
              <List.Item>{newAddress.level2}</List.Item>
              <List.Item>{newAddress.level1}</List.Item>
              <List.Item>{newAddress.postalCode}</List.Item>
              <List.Item>{newAddress.country}</List.Item>
            </List>
          </Table.Cell>
        </Table.Row>)}
        {contactName && ( <Table.Row>
          <Table.Cell>Contact</Table.Cell>
          <Table.Cell>
            <List>
              <List.Item>Name: {contactName}</List.Item>
              <List.Item>Mobile: {contactMobile}</List.Item>
              <List.Item>Telephone: {contactTelephone}</List.Item>
            </List>
          </Table.Cell>
        </Table.Row>)}
        {specialNotes !== '' && (<Table.Row style={{fontSize: 'smaller'}}>
          <Table.Cell>Notes</Table.Cell>
          <Table.Cell>
            <p style={{whiteSpace : "pre-wrap"}}>
              {specialNotes}
            </p>
            </Table.Cell>
        </Table.Row>)}
      </Table.Body>
    </Table>
  );
};

export default PortingDetails;
